import React from "react";
import { ITabSetCategory } from "../../interfaces/ITabSetCategory";
import Icon from "../icon/icon";

export interface ICategoryButtonProps {
  category: ITabSetCategory;
  selected?: boolean | null;
  hoverable?: boolean | null;
  onMouseEnter: (category: ITabSetCategory) => void;
  onMouseLeave: (category: ITabSetCategory) => void;
}

function CategoryButton(props: ICategoryButtonProps) {
  return (
    <>
      <a href={props.category.linkUrl}>
        <button
          className={
            "category-button align-middle" +
            (props.selected ? " selected" : props.hoverable ? " hoverable" : "")
          }
          onMouseEnter={() => {
            props.onMouseEnter(props.category);
          }}
          onMouseLeave={() => {
            props.onMouseLeave(props.category);
          }}
        >
          {props.category.icon && (
            <Icon className="d-block">{props.category.icon}</Icon>
          )}
          {props.category.menuIconImage && (
            <img
              className="d-block category-image"
              src={props.category.menuIconImage}
              alt={props.category.name}
            />
          )}
          <div className="category-name">{props.category.name}</div>
        </button>
      </a>
    </>
  );
}

export default CategoryButton;
